import { RemirrorJSON } from "@remirror/core";
import { ColorOrTransparent } from "./types";
import { Colors } from "@zapier/design-system";

export function getColorDotStyling(color: ColorOrTransparent, size = 22) {
  return {
    borderRadius: "50%",
    backgroundColor: color,
    width: size,
    height: size,
    border:
      color === "#fff" || color === "transparent"
        ? `1px solid ${color === "#fff" ? Colors.GrayWarm6 : "#ccc"}`
        : "none",
  };
}

export function isRemirrorJSONEmpty(
  notesJson: RemirrorJSON | undefined,
): boolean {
  if (!notesJson) {
    return true;
  }
  // If the node has a text property and it is not empty, return false
  if (notesJson.text && notesJson.text.trim() !== "") {
    return false;
  }

  // If the node has content, recursively check each child node
  if (notesJson.content && notesJson.content.length > 0) {
    return notesJson.content.every(isRemirrorJSONEmpty);
  }

  // If the node has no text and no content, it is empty
  return true;
}
